export default __webpack_public_path__ + "static/media/guasasapo-fondo-casa-enhanced-v2.ea7285ca.jpg";